export const languages = {
  en: {
    id: 'en',
    label: 'English',
    flag: 'GB',
    antd: () => import('antd/locale/en_GB'),
    date: () => import('dayjs/locale/en-gb'),
  },
  ro: {
    id: 'ro',
    label: 'Romanian',
    flag: 'RO',
    antd: () => import('antd/locale/ro_RO'),
    date: () => import('dayjs/locale/ro'),
  },

  fr: {
    id: 'fr',
    label: 'French',
    flag: 'FR',
    antd: () => import('antd/locale/fr_FR'),
    date: () => import('dayjs/locale/fr'),
  },

  bg: {
    id: 'bg',
    label: 'Bulgarian',
    flag: 'BG',
    antd: () => import('antd/locale/bg_BG'),
    date: () => import('dayjs/locale/bg'),
  },
  cs: {
    id: 'cs',
    label: 'Czech',
    flag: 'CZ',
    antd: () => import('antd/locale/cs_CZ'),
    date: () => import('dayjs/locale/cs'),
  },
  da: {
    id: 'da',
    label: 'Danish',
    flag: 'DK',
    antd: () => import('antd/locale/da_DK'),
    date: () => import('dayjs/locale/da'),
  },
  de: {
    id: 'de',
    label: 'German',
    flag: 'DE',
    antd: () => import('antd/locale/de_DE'),
    date: () => import('dayjs/locale/de'),
  },
  el: {
    id: 'el',
    label: 'Greek',
    flag: 'GR',
    antd: () => import('antd/locale/el_GR'),
    date: () => import('dayjs/locale/el'),
  },
  es: {
    id: 'es',
    label: 'Spanish',
    flag: 'ES',
    antd: () => import('antd/locale/es_ES'),
    date: () => import('dayjs/locale/es'),
  },
  et: {
    id: 'et',
    label: 'Estonian',
    flag: 'ET',
    antd: () => import('antd/locale/et_EE'),
    date: () => import('dayjs/locale/et'),
  },
  fi: {
    id: 'fi',
    label: 'Finnish',
    flag: 'FI',
    antd: () => import('antd/locale/fi_FI'),
    date: () => import('dayjs/locale/fi'),
  },
  ga: {
    id: 'ga',
    label: 'Irish',
    flag: 'GA',
    antd: () => import('antd/locale/ga_IE'),
    date: () => import('dayjs/locale/ga'),
  },
  hr: {
    id: 'hr',
    label: 'Croatian',
    flag: 'HR',
    antd: () => import('antd/locale/hr_HR'),
    date: () => import('dayjs/locale/hr'),
  },
  hu: {
    id: 'hu',
    label: 'Hungarian',
    flag: 'HU',
    antd: () => import('antd/locale/hu_HU'),
    date: () => import('dayjs/locale/hu'),
  },
  it: {
    id: 'it',
    label: 'Italian',
    flag: 'IT',
    antd: () => import('antd/locale/it_IT'),
    date: () => import('dayjs/locale/it'),
  },
  lt: {
    id: 'lt',
    label: 'Lithuanian',
    flag: 'LT',
    antd: () => import('antd/locale/lt_LT'),
    date: () => import('dayjs/locale/lt'),
  },
  lv: {
    id: 'lv',
    label: 'Latvian',
    flag: 'LV',
    antd: () => import('antd/locale/lv_LV'),
    date: () => import('dayjs/locale/lv'),
  },
  mt: {
    id: 'mt',
    label: 'Maltese',
    flag: 'MT',
    antd: () => import('antd/locale/en_GB'),
    date: () => import('dayjs/locale/mt'),
  },
  nl: {
    id: 'nl',
    label: 'Dutch',
    flag: 'NL',
    antd: () => import('antd/locale/nl_NL'),
    date: () => import('dayjs/locale/nl'),
  },
  pl: {
    id: 'pl',
    label: 'Polish',
    flag: 'PL',
    antd: () => import('antd/locale/pl_PL'),
    date: () => import('dayjs/locale/pl'),
  },
  pt: {
    id: 'pt',
    label: 'Portuguese',
    flag: 'PT',
    antd: () => import('antd/locale/pt_PT'),
    date: () => import('dayjs/locale/pt'),
  },
  sk: {
    id: 'sk',
    label: 'Slovak',
    flag: 'SK',
    antd: () => import('antd/locale/sk_SK'),
    date: () => import('dayjs/locale/sk'),
  },
  sl: {
    id: 'sl',
    label: 'Slovenian',
    flag: 'SL',
    antd: () => import('antd/locale/sl_SI'),
    date: () => import('dayjs/locale/sl'),
  },
  sv: {
    id: 'sv',
    label: 'Swedish',
    flag: 'SV',
    antd: () => import('antd/locale/sv_SE'),
    date: () => import('dayjs/locale/sv'),
  },
  az: {
    id: 'az',
    label: 'Azerbaijani',
    flag: 'AZ',
    antd: () => import('antd/locale/az_AZ'),
    date: () => import('dayjs/locale/az'),
  },
  ru: {
    id: 'ru',
    label: 'Russian',
    flag: 'RU',
    antd: () => import('antd/locale/ru_RU'),
    date: () => import('dayjs/locale/ru'),
  },
};
